import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import { atomRuleDataRaw } from '@/src/modules/RulesModule/atoms/rules';

import { atomActionData } from '@/modules/CampaignsModule/atoms/campaignAtom';
import { STATES_PROCESS_ACTION } from '@/modules/CampaignsModule/constants';

export const useRuleStatus = () => {
  const rulesDataRaw = useAtomValue(atomRuleDataRaw);
  const actionData = useAtomValue(atomActionData);

  const status = actionData?.status ?? 0;

  const isRuleActive = useMemo(() => {
    //cspell: disable-next-line
    return rulesDataRaw?.activo ?? false;
  }, [rulesDataRaw]);

  const isRuleReadyForActivate = useMemo(() => {
    return STATES_PROCESS_ACTION.confirmableDraft.includes(status);
  }, [status]);

  const isRuleInactive = useMemo(() => {
    return STATES_PROCESS_ACTION.inactive.includes(status);
  }, [status]);

  return { isRuleActive, isRuleReadyForActivate, isRuleInactive };
};
